import { format } from 'date-fns';
import { StyleSheet, TouchableOpacity, View } from 'react-native';
import { mvs } from 'react-native-size-matters';

import { useAppSelector } from '../../app/hooks';
import { COLORS, IS_WEB } from '../../constants';
import { selectDivRadius } from '../../features/appconfig/store/selectors';
import { selectCurrentRadioSongHistoryConfig } from '../../features/currentradio/store/selectors';
import { useAdjustedFontSize } from '../../hooks/useAdjustedFontSize';
import { CustomIcon } from '../CustomIcon';
import CustomText from '../CustomText';

interface Props {
  date: Date | null;
  time: Date | null;
  onOpenPicker: (mode: 'date' | 'time') => void;
}

export const SongHistoryFilters = ({ date, time, onOpenPicker }: Props) => {
  const divRadius = useAppSelector(selectDivRadius);
  const dateTextFontSize = useAdjustedFontSize(mvs(16));
  const songHistoryConfig = useAppSelector(selectCurrentRadioSongHistoryConfig);

  const dateContent = (
    <>
      <CustomIcon name="calendar" color="#252525" size={mvs(16)} />
      <CustomText
        style={[styles.dateText, { fontSize: dateTextFontSize }]}
        weight="SemiBold"
      >
        {format(date || new Date(), 'dd/MM/yyyy')}
      </CustomText>
    </>
  );

  const timeContent = (
    <>
      <CustomIcon name="clock" color="#252525" size={mvs(16)} />
      <CustomText
        style={[styles.dateText, { fontSize: dateTextFontSize }]}
        weight="SemiBold"
      >
        {format(time || new Date(), 'HH:mm')}
      </CustomText>
    </>
  );

  if (
    !songHistoryConfig?.dateOptionAvailable &&
    !songHistoryConfig?.timeOptionAvailable
  ) {
    return;
  }

  return (
    <View style={styles.container}>
      <View style={styles.dateFilters}>
        {/* date picker - on web render as plain view, on mobile as touchable */}
        {songHistoryConfig?.dateOptionAvailable &&
          (IS_WEB ? (
            <View
              style={[
                styles.filterButton,
                styles.dateButton,
                { borderRadius: divRadius },
              ]}
            >
              {dateContent}
            </View>
          ) : (
            <TouchableOpacity
              style={[
                styles.filterButton,
                styles.dateButton,
                { borderRadius: divRadius },
              ]}
              onPress={() => onOpenPicker('date')}
            >
              {dateContent}
            </TouchableOpacity>
          ))}

        {/* time picker - on web render as plain view, on mobile as touchable */}
        {songHistoryConfig?.timeOptionAvailable &&
          (IS_WEB ? (
            <View
              style={[
                styles.filterButton,
                styles.timeButton,
                { borderRadius: divRadius },
              ]}
            >
              {timeContent}
            </View>
          ) : (
            <TouchableOpacity
              style={[
                styles.filterButton,
                styles.timeButton,
                { borderRadius: divRadius },
              ]}
              onPress={() => onOpenPicker('time')}
            >
              {timeContent}
            </TouchableOpacity>
          ))}
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    width: '100%',
    alignItems: 'center',
  },
  dateFilters: {
    flexDirection: 'row',
    gap: mvs(8),
    maxWidth: mvs(330),
    width: '100%',
  },
  filterButton: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: mvs(8),
    paddingHorizontal: mvs(16),
    paddingVertical: mvs(8),
    backgroundColor: COLORS.WHITE,
  },
  dateButton: {
    flex: 1,
  },
  timeButton: {
    flexShrink: 0,
    alignSelf: 'flex-start',
  },
  dateText: {
    color: '#252525',
  },
});
